export default
{
    watch:
    {
        statusCode:
        {
            handler( value )
            {
                if( !this.isLoading && value !== 200 )
                {
                    setTimeout( () => { this.statusCode = 200 }, 3000 );
                }
            }
        },

        modelValue:
        {
            immediate: true,

            handler( value )
            {
                if( value && ( typeof value === 'object' ) )
                {
                    if( !Array.isArray( value ) && !this.uploadedFiles.find( f => ( f.size === value.size ) && ( f.type === value.type ) ) )
                    {
                        this.setInternalValueFromModelValue( value );
                    }
                    else if( Array.isArray( value ) && value.length )
                    {
                        value.forEach( file =>
                        {
                            if( !this.uploadedFiles.find( f => ( f.size === file.size ) && ( f.type === file.type ) ) )
                            {
                                this.setInternalValueFromModelValue( file );
                            }
                        });
                    }
                }
            }
        }
    }
}
